import { createAuthClient } from "better-auth/react";
import { twoFactorClient } from "better-auth/client/plugins";

/**
 * The panel's half of Better Auth (decision 48).
 *
 * The session is an `HttpOnly` cookie the browser sends by itself, so there
 * is no token to hold here — the panel never sees it, and script on the page
 * cannot read it. That only works while the panel and the Admin API share one
 * origin, which is why decision 32's single-origin rule now binds production
 * too (design §3).
 */
export const authClient = createAuthClient({
  // Same origin: the API is served at /api on this very host.
  basePath: "/api/auth",
  plugins: [twoFactorClient()],
});

export const { signIn, signOut, twoFactor, useSession } = authClient;
